export default "__VITE_ASSET__DV$RgjMq__"